const ITEMS = ["Marlene Alesna", "Independent Buyer's Agent", "eXp Realty", "Oahu", "Kali'u Ala Moana", "From $890,000", "728 Ala Moana Blvd"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((t, i) => (
      <span key={i} className="flex items-center">
        <span className="font-serif italic font-light text-2xl md:text-3xl text-charcoal/70 px-8 md:px-12 whitespace-nowrap">{t}</span>
        <span className="w-1.5 h-1.5 rounded-full bg-teal/50" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div className="bg-sand border-y border-line py-6 overflow-hidden" data-testid="editorial-marquee">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
